import { styled, Box } from "@mui/material";
import { WIDGET_GEOMETRY } from "../../iframe/widgetGeometry";

// Shared with the iframe host bridge — see widgetGeometry.ts.
const MinimizedChatBubble = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.widgetStyles.minimizedChatBubble.backgroundColor,
  borderRadius: "50%",
  height: `${WIDGET_GEOMETRY.bubbleSize}px`,
  width: `${WIDGET_GEOMETRY.bubbleSize}px`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "fixed",
  bottom: `${WIDGET_GEOMETRY.margin}px`,
  right: `${WIDGET_GEOMETRY.margin}px`,
  cursor: "pointer",
  zIndex: 2000,

  "&:hover": {
    backgroundColor: theme.palette.widgetStyles.minimizedChatBubble.hoverColor,
  },
}));

export default MinimizedChatBubble;
